<script setup lang="ts">
import { ref } from 'vue';
import Tab from 'primevue/tab';
import TabList from 'primevue/tablist';
import TabPanel from 'primevue/tabpanel';
import TabPanels from 'primevue/tabpanels';
import Tabs from 'primevue/tabs';
import PromoAdditionalAgency from '@/components/modal/worksheet/PromoAdditionalAgency.vue';
import TermsConditions from '@/components/modal/worksheet/TermsConditions.vue';
import TourOptionDetail from './TourOptionDetail.vue';

interface Props {
  multiDayTour: any;
  langQuote?: string;
  quoteId?: string;
  tourWorkSheet: any;
}
const props = defineProps<Props>();

const emits = defineEmits<{
  handleSaveDataEdit: [value: any];
  handleSaveDataEditTerm: [value: any];
  saveWorksheet: [];
}>();

const multiDayTourRef = ref(props.multiDayTour);

const handleSaveDataEdit = (event: any, index: number) => {
  multiDayTourRef.value[index][event.field] = event.value;
  emits('handleSaveDataEdit', multiDayTourRef.value);
};
const handleSaveDataEditTerm = (event: any) => {
  emits('handleSaveDataEditTerm', event);
};

const handleTours = (event: any, index: any) => {
  multiDayTourRef.value[index].tours = event;
  multiDayTourRef.value[index].netMargin = event.netMargin;
  delete multiDayTourRef.value[index].tours.netMargin;
  emits('handleSaveDataEdit', multiDayTourRef.value);
};

const saveWorksheet = () => {
  emits('saveWorksheet');
};
</script>
<template>
  <div>
    <Tabs :value="0">
      <TabList>
        <Tab v-for="(_, index) in multiDayTour" :key="index" :value="index">{{ $t('common.option') + ' ' + Number(index + 1) }}</Tab>
        <Tab :key="multiDayTour.length + 1" :value="multiDayTour.length + 1">{{ $t('menu.term_and_condition') }}</Tab>
      </TabList>
      <TabPanels>
        <TabPanel v-for="(tours, index) in multiDayTour" :key="index" :value="index">
          <TourOptionDetail :tours="tours.tours" :toursInfo="tours" :tabindex="index" :tourWorkSheet="tourWorkSheet" :langQuote="langQuote" :quoteId="quoteId" @handleTours="handleTours($event, index)" @saveWorksheet="saveWorksheet()" />
          <PromoAdditionalAgency :isOutsideTours="true" :tours="tours" @handleSaveDataEdit="handleSaveDataEdit($event, index)" />
        </TabPanel>
        <TabPanel :value="multiDayTour.length + 1">
          <TermsConditions :tourWorkSheet="tourWorkSheet" @handleSaveDataEditTerm="handleSaveDataEditTerm($event)" />
        </TabPanel>
      </TabPanels>
    </Tabs>
  </div>
</template>
